<template>
	<v-container fluid>
		<v-row class="mb-3">
			<v-col cols="7" md="6" class="d-flex align-center">
				<div class="d-flex align-center">
					<v-icon class="me-5" style="color: #ff7e87" size="40">mdi-account</v-icon>
					<p class="text-lg-h5 font-weight-600">
						{{ $t('profile') }}
					</p>
				</div>
			</v-col>
		</v-row>

		<v-card rounded="xl">
			<v-card-header>
				<div style="height: 12rem; background-color: #ffc2c6"></div>
			</v-card-header>

			<v-card-text>
				<div>
					<v-avatar color="grey" size="150" class="ml-5" style="margin-top: -7rem; position: relative"
						:image="details?.pictureUrl">
					</v-avatar>
					<v-btn size="45" icon="" style="
							position: absolute;
							left: 140px;
							z-index: 999;
							background-color: rgba(17, 17, 17, 0.7);
						" @click="pickFile">
						<v-icon size="24" class="text-white">
							mdi-image-edit
						</v-icon>
						<input ref="fileRef" class="d-none" type="file" @change="uploadImage($event)"></input>
					</v-btn>

					<div class="ml-5 mt-5">
						<div class="text-h6 my-3"> {{ $t('account_information') }}</div>

						<v-row>
							<v-col cols="6">
								<div class="mb-2 text-subtitle-1 font-weight-small">
									{{ $t('first_name') }}
								</div>
								<v-text-field :placeholder="$t('first_name')" variant="outlined"
									v-model="details.firstName"></v-text-field>
							</v-col>

							<v-col cols="6">
								<div class="mb-2 text-subtitle-1 font-weight-small">
									{{ $t('last_name') }}
								</div>
								<v-text-field v-model="details.lastName" :placeholder="$t('last_name')"
									variant="outlined"></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="6">
								<div class="mb-2 text-subtitle-1 font-weight-small">
									{{ $t('phone_number') }}
								</div>
								<v-text-field :placeholder="$t('phone_number')" v-model="details.phone"
									variant="outlined"></v-text-field>
							</v-col>

							<v-col cols="6">
								<div class="mb-2 text-subtitle-1 font-weight-small">
									{{ $t('department') }}
								</div>
								<v-text-field v-model="details.specialization" :placeholder="$t('department')"
									variant="outlined"></v-text-field>
							</v-col>
						</v-row>
					</div>

					<div class="d-flex flex-row-reverse">
						<v-btn class="text-none" style="width: 250px" rounded="xl" color="#FF7E87" size="large"
							@click=saveUserProfile()>{{ $t('save_change') }}</v-btn>
					</div>
				</div>
			</v-card-text>
		</v-card>
		<v-snackbar v-model="snackbar" :timeout="5000" rounded="pill" color="#8EEDB3" width="500px">
			<div class="d-flex mx-2">
				<v-icon>mdi-check</v-icon>
				<p class="mx-2">Profile has been saved .</p>
			</div>
			<template v-slot:actions>
				<div class="mx-2">
					<v-icon color="black" @click="snackbar = false">
						mdi-close
					</v-icon>
				</div>
			</template>
		</v-snackbar>
	</v-container>
</template>

<script>
import userProfile from '@/services/API/userProfile'

export default {
	data: () => ({
		details: {},
		file: null,
		snackbar: false
	}),

	created() {
		this.listUser()
	},

	methods: {
		async listUser() {
			await userProfile.getAdminInformation().then((response) => {
				this.details = response.data.data
			})
		},
		pickFile() {
			this.$refs.fileRef.click()
		},
		uploadImage(event) {
			const file = event.target.files[0];

			if (file) {
				if (this.details.pictureUrl) {
					URL.revokeObjectURL(this.details.pictureUrl);
				}
				this.file = file
				this.details.pictureUrl = URL.createObjectURL(file);
			}
		},
		async saveUserProfile() {
			await userProfile.updateAdminInformation(this.details, this.file).then((response) => {
				if (response.status == 200) {
					this.snackbar = true
					setTimeout(() => {
						location.reload();
					}, 2000);
				}
			})
		},

	},
}
</script>
<style scoped></style>
